import React from "react";

import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import Timer from "./Timer";
import LanguageSelector from "../LanguageSelector";
import { sendOtp, verifyOtp } from "../gateway/OtpGateway";
import { ARGUS_APM } from "../../apm";
import Types from "prop-types";
import { fetchGuardToken, ReCaptcha } from "../Guard";

class OtpView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showResendTimer: true,
      error: null,
      otp: "",
      submitting: false,
    };
    this.textInput = React.createRef();
    this.resendOtp(this.isEmail() ? "EMAIL" : "SMS");
  }

  isEmail() {
    return this.props.identifier.indexOf("@") > 0;
  }

  async resendOtp(type) {
    try {
      await sendOtp({
        type,
        guard: await fetchGuardToken(),
        identifier: this.props.identifier,
        clientId: this.props.clientId,
      });
      this.setState({ showResendTimer: true });
    } catch (e) {
      this.onRequestError(e);
    }
  }

  async onSubmit(event) {
    event.preventDefault();

    this.setState({
      submitting: true,
      error: null,
    });

    try {
      let { data } = await verifyOtp({
        identifier: this.props.identifier,
        code: this.state.otp,
        clientId: this.props.clientId,
      });
      this.props.onOtpVerify(data.id);
    } catch (e) {
      this.onRequestError(e);
    } finally {
      this.setState({ submitting: false });
    }
  }

  renderResendButton(type, caption) {
    const { showResendTimer } = this.state;

    let onClick = (e) => {
      this.resendOtp(type);
      this.setState({
        otp: "",
        error: null,
      });
      this.textInput.focus();
      e.preventDefault();
    };

    return (
      <input
        type="reset"
        name={type}
        className="resend-btn"
        onClick={onClick}
        disabled={showResendTimer}
        value={caption}
      />
    );
  }

  onRequestError(e) {
    ARGUS_APM.captureError(e);
    if (e.response?.data) {
      this.setState({ error: e.response.data });
    } else {
      this.setState({ error: { message: "ERROR_UNKNOWN" } });
    }
  }

  onFinishTimer() {
    this.setState(() => ({
      showResendTimer: false,
    }));
  }

  render() {
    const { t, submitError, identifier } = this.props;
    const { error, showResendTimer, submitting } = this.state;
    let timer = showResendTimer && (
      <Timer onFinish={this.onFinishTimer.bind(this)} timeInSecs={60} />
    );
    return (
      <form onSubmit={this.onSubmit.bind(this)} autoComplete="off">
        <LanguageSelector />
        <h1>{t("otp:verification_field")}</h1>
        <h3>
          {t("otp:check_otp")} {identifier}
        </h3>

        {!submitError && error && (
          <div className="invalid show">
            {t(["otp:error." + error.message, "error:default"])}
          </div>
        )}
        {submitError && <div className="invalid show">{submitError}</div>}
        <div className="material-form-field ">
          <input
            type="text"
            autoComplete="off"
            spellCheck="false"
            name="otp_code"
            value={this.state.otp}
            onChange={(event) => this.setState({ otp: event.target.value })}
            required
            autoFocus
            ref={(ref) => (this.textInput = ref)}
          />
          <label className="material-form-field-label">
            {t("otp:enter_otp")}
          </label>
        </div>
        <div>
          <h3 className="otp-resend-text">
            {t("otp:resend_otp_text")} &nbsp;
            {!this.isEmail() && (
              <span>
                {this.renderResendButton("SMS", t("otp:resend_otp_code"))}
                <span className="resend-delimiter">|</span>
                {this.renderResendButton("VOICE", t("otp:resend_otp_voice"))}
              </span>
            )}
            {this.isEmail() && (
              <span>
                {this.renderResendButton("EMAIL", t("otp:resend_otp_code"))}
              </span>
            )}
            {timer}
          </h3>
        </div>

        <input
          className="btn-careem"
          type="submit"
          value={submitting ? t("common:please_wait") : t("common:continue")}
          disabled={submitting}
        />
        <ReCaptcha />
      </form>
    );
  }
}

OtpView.propTypes = {
  clientId: Types.string,
  identifier: Types.string.isRequired,
};

export default withRouter(withTranslation()(OtpView));
export const OtpViewUnwrapped = OtpView;
